import { MarketplaceComponentConfig } from '@nocode/types';

export default {
  name: 'StarRate',
  displayName: {
    en: 'StarRate',
    ja: '星評価',
  },
  defaultWidth: 152,
  defaultHeight: 30,
  resizeX: true,
  resizeY: false,
  props: [
    {
      name: 'icon',
      displayName: {
        en: 'Icon',
        ja: 'アイコン',
      },
      type: 'icon',
      default: 'star',
    },
    {
      name: 'outlineIcon',
      displayName: {
        en: 'Outline Icon',
        ja: 'アウトラインアイコン',
      },
      type: 'icon',
      default: 'star-outline',
    },
    {
      name: 'value',
      displayName: '',
      role: 'formValue',
      type: 'number',
    },
    {
      name: 'currentValue',
      displayName: {
        en: 'Value',
        ja: '値',
      },
      type: 'number',
      default: 0,
      conditions: {
        min: 0,
      },
    },
    {
      name: 'maxValue',
      displayName: {
        en: 'Max Value',
        ja: '最大値',
      },
      type: 'number',
      default: 5,
    },
    {
      name: 'editable',
      displayName: {
        en: 'Editable',
        ja: '編集可能',
      },
      type: 'switch',
      default: false,
    },
    {
      name: 'fontColor',
      displayName: {
        en: 'Color',
        ja: '色',
      },
      type: 'color',
      default: '#000000',
    },
    {
      name: 'fontSize',
      displayName: {
        en: 'Size',
        ja: 'サイズ',
      },
      type: 'fontSize',
    },
    {
      name: 'onPress',
      displayName: {
        en: 'On Press',
        ja: '押下時',
      },
      type: 'action',
    },
  ],
  style: {
    opacity: true,
    fontSize: true,
    color: true,
  },
} as MarketplaceComponentConfig;
